module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), (_vm.department == 'Admin') ? _c('h4', {
    staticClass: "text-danger"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isMerge),
      expression: "isMerge"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isMerge) ? _vm._i(_vm.isMerge, null) > -1 : (_vm.isMerge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isMerge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isMerge = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isMerge = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isMerge = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("是否整合南北向數據報表")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "custom-functions-wrapper"
  }, _vm._l((_vm.reportFunctions), function(func) {
    return _c('div', {
      staticClass: "custom-function"
    }, [_c('h5', [_vm._v(" " + _vm._s(func.name))]), _c('hr'), _c('QueryFilter', {
      attrs: {
        "showDate": func.query_by_date,
        "showEventType": false,
        "showSystem": false,
        "showFilterButton": false
      },
      on: {
        "report": function($event) {
          return _vm.report($event, func.function_name, func.name, func.query_by_date)
        }
      }
    })], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("違規停車報表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b377242","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ReportExport/CrossLineReport.vue
// module id = 1378
// module chunks = 1